import React from 'react';
import { LoginPrompt } from './LoginPrompt';
import { ChangePasswordPrompt } from './ChangePasswordPrompt';
import { ForgotPasswordPrompt } from './ForgotPasswordPrompt';
import { DB } from '@tonic/central-specialties-utils';
export const AuthRoutes = ({ Route }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Route, { path: "login", element: React.createElement(LoginPrompt, null) }),
        React.createElement(Route, { path: "create-password", element: React.createElement(ChangePasswordPrompt, { initial: true }) }),
        React.createElement(Route, { path: "forgot-password", element: React.createElement(ForgotPasswordPrompt, { onSubmit: async (employeeNumber) => {
                    const { error } = await DB.POST('/users/forgot-password', {
                        body: {
                            employeeNumber,
                        },
                    });
                    if (error) {
                        throw error;
                    }
                } }) })));
};
